import React, { useState, useEffect } from 'react';
import Header from './components/Header.tsx';
import Hero from './components/Hero.tsx';
import TwoEngine from './components/TwoEngine.tsx';
import TalentGrid from './components/TalentGrid.tsx';
import TechStack from './components/TechStack.tsx';
import VettingProcess from './components/VettingProcess.tsx';
import CallToAction from './components/CallToAction.tsx';
import Footer from './components/Footer.tsx';
import Solutions from './components/Solutions.tsx';
import TalentPage from './components/TalentPage.tsx';
import CaseStudies from './components/CaseStudies.tsx';
import About from './components/About.tsx';
import ContactModal from './components/ContactModal.tsx';
import TrustBar from './components/TrustBar.tsx';
import { AppSection } from './types.ts';

const App: React.FC = () => {
  const [activeSection, setActiveSection] = useState<AppSection>(AppSection.Home);
  const [isContactOpen, setIsContactOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeSection]);

  const navigate = (section: AppSection) => {
    setActiveSection(section);
  };

  const renderContent = () => {
    switch (activeSection) {
      case AppSection.Solutions:
        return <Solutions onNavigate={navigate} onContactClick={() => setIsContactOpen(true)} />;
      case AppSection.Talent:
        return <TalentPage onNavigate={navigate} onContactClick={() => setIsContactOpen(true)} />;
      case AppSection.CaseStudies:
        return <CaseStudies onNavigate={navigate} onContactClick={() => setIsContactOpen(true)} />;
      case AppSection.About:
        return <About onNavigate={navigate} onContactClick={() => setIsContactOpen(true)} />;
      default:
        return (
          <>
            <Hero onNavigate={navigate} onContactClick={() => setIsContactOpen(true)} />
            <TrustBar />
            <TwoEngine onNavigate={navigate} />
            <TalentGrid />
            <TechStack />
            <VettingProcess />
            <CallToAction onNavigate={navigate} />
          </>
        );
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 selection:bg-[#facc15] selection:text-slate-900">
      <Header 
        activeSection={activeSection}
        onNavigate={navigate} 
        onContactClick={() => setIsContactOpen(true)}
      />
      
      <main className="flex-grow">
        {renderContent()}
      </main>

      <Footer onNavigate={navigate} />
      
      <ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)} 
      />
    </div>
  );
};

export default App;